import React, { createContext, useState, useContext, useEffect } from "react";

// Crear el contexto
const PropertyContext = createContext();

// Crear el Provider
export const PropertyProvider = ({ children }) => {
  const [property, setProperty] = useState(() => {
    return localStorage.getItem("currentProperty") || null;
  });

  // Sincronizar con cambios en localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      const newProperty = localStorage.getItem("currentProperty");
      if (newProperty !== property) {
        console.log("Actualizando propiedad desde localStorage:", newProperty);
        setProperty(newProperty);
      }
    };

    // Escuchar eventos de storage (para cambios en otras pestañas)
    window.addEventListener("storage", handleStorageChange);

    // Escuchar cambios manuales en localStorage en la misma pestaña
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "currentProperty") {
        handleStorageChange();
      }
    };

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      localStorage.setItem = originalSetItem;
    };
  }, [property]);

  return (
    <PropertyContext.Provider value={{ property, tracking: false, setProperty }}>
      {children}
    </PropertyContext.Provider>
  );
};

// Hook personalizado para usar el contexto
export const useProperty = () => {
  const context = useContext(PropertyContext);
  if (!context) {
    throw new Error("useProperty must be used within a PropertyProvider");
  }
  return context;
};